import { emsClient } from '../api/clients';

export async function activateLiveVideo(incidentId: string): Promise<void> {
  const { response } = await emsClient().POST(
    '/v1/incidents/{incidentId}/caller/live-video/activate',
    {
      params: { path: { incidentId } },
    },
  );

  ensureSuccess(response, 'Activate caller live video');
}

function ensureSuccess(response: Response, action: string): void {
  if (!response.ok) {
    throw new Error(`${action} failed (HTTP ${response.status})`);
  }
}
